import { createContext, useContext, useEffect, useState } from 'react'
import { getItem, removeItem, setItem } from '../utils/storage'

const AnimationsContext = createContext()

const LS_KEY = 'animationsEnabled'
const MQL = '(prefers-reduced-motion: reduce)'

const getSystemPRM = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  try { return window.matchMedia(MQL).matches } catch (e) { return false }
}

export function AnimationsProvider ({ children }) {
  const [animationsEnabled, setAnimationsEnabled] = useState(() => {
    const stored = getItem(LS_KEY)
    if (stored !== null) return stored === 'true'
    return !getSystemPRM()
  })

  useEffect(() => {
    const root = document.documentElement
    root.classList.toggle('animations-disabled', !animationsEnabled)
    setItem(LS_KEY, animationsEnabled)
  }, [animationsEnabled])

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mq = window.matchMedia(MQL)

    const handleChange = () => {
      const hasUserOverride = getItem(LS_KEY)
      if (hasUserOverride === null) {
        setAnimationsEnabled(!mq.matches)
      }
    }

    mq.addEventListener('change', handleChange)
    return () => mq.removeEventListener('change', handleChange)
  }, [])

  const toggleAnimations = () => setAnimationsEnabled(prev => !prev)

  const resetAnimationsToSystem = () => {
    removeItem(LS_KEY)
    setAnimationsEnabled(!getSystemPRM())
  }

  return (
    <AnimationsContext.Provider value={{ animationsEnabled, toggleAnimations, resetAnimationsToSystem }}>
      {children}
    </AnimationsContext.Provider>
  )
}

export function useAnimations () {
  const context = useContext(AnimationsContext)
  if (!context) {
    throw new Error('useAnimations must be used within an AnimationsProvider')
  }
  return context
}
